// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__PjBUD","loginHeader":"Login_loginHeader__2GMdo","content":"Login_content__21R4P","emailIcon":"Login_emailIcon__9i415"};